import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Page from './components/page-component.vue';
  import { IProgram } from '@/types/program';

  export interface IProps {
    program: IProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

  ;

  

  const cards = [
    {
      name: '수거 가능 품목',
      content: [
        {
          text: '브리타 막스트라 플러스 필터'
        },
        {
          text: '(타 브랜드 제품은 수거 및 재활용이<br class="d-block d-md-none"> 불가능하니 유의해 주세요!)'
        }
      ],
      tips: [],
      descriptions: [
        {
          text: '브리타는 필터 1개로 150리터 만큼의 <br class="d-block d-md-none">일회용 플라스틱 사용량을 줄이는 것에서 더 나아가 브리타<br class="d-none d-md-block">필터를 <br class="d-block d-md-none">재활용하는 ‘브리타 그린 리프 멤버십’을 테라사이클과 함께 합니다.'
        }
      ]
    },
    {
      name: '참여 방법',
      content: [
        {
          text: '1. 다 사용한 브리타 필터는 잘 말려 완전히 건조해 주세요.'
        },
        {
          text: '<br class="d-block d-md-none">'
        },
        {
          text: '2. 브리타 필터 9개 이상을 모아 종이 박스에 포장해 문 앞에 놔주세요.'
        },
        {
          text: '(9개부터 필터 수거 신청 가능합니다.)'
        },
        {
          text: '<br class="d-block d-md-none">'
        },
        {
          text: '3. 가플지우 캠페인 사이트에서 해당하는 품목의 수거 신청하기 버튼을 클릭해 주세요.'
        },
        {
          text: '<br>'
        },
        {
          text: '* 환경을 위해 1박스에 최대한 많은 필터를 담아 보내주세요.'
        },
        {
          text: '필터를 최대한 많이 모아 1박스에 보내주시면 여러 택배 박스를 보내시는 것보다'
        },
        {
          text: '탄소 배출 저감에 기여할 수 있습니다.'
        },
      ],
      tips: [
        {
          text: '- 수거품을 담는 박스는 가로*세로*높이 세 변의 합이 140cm 미만의 박스로 부탁드립니다.'
        },
        {
          text: '- 영업일 기준 3~4일 내로 택배기사님이 방문하시어 수거하실 예정입니다.'
        }
      ]
    },
    {
      name: '유의 사항',
      content: [
        {
          text: '필터는 9개 이상이라면 개수 제한없이 모두 1박스에 담아 수거 가능합니다.'
        },
        {
          text: '다만, 크기가 너무 큰 박스를 사용하거나 1박스의 무게가 20kg가 넘지 않도록'
        },
        {
          text: '주의해 주세요.'
        },
        {
          text: '예시) 필터 12개 = 1박스 포장'
        }
      ],
      tips: []
    }
  ];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, {
    title: "[브리타 필터 재활용 참여 안내]",
    subtitle: "수거 신청 전 한 번 더 확인해주세요.",
    image: require('./images/program-2.png'),
    cards: cards,
    program: __props.program
  }, null, 8, ["image", "program"]))
}
}

})